var $56b5617927e3f333$exports = {};
$56b5617927e3f333$exports = {
    "info": `Informa\u{21B}ii`,
    "negative": `Eroare`,
    "positive": `Succes`
};


export {$56b5617927e3f333$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
